// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/OrgRoleFunction.yaml
// Generated: 2026-06-15T05:18:46.875Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateOrgRoleFunction, UpdateOrgRoleFunction, OrgRoleFunction } from '@/types/core/OrgRoleFunction';

/**
 * OrgRoleFunction Service
 * CRUD operations for OrgRoleFunction via the ABP API.
 */
export const orgRoleFunctionService = new EntityService<OrgRoleFunction, CreateOrgRoleFunction, UpdateOrgRoleFunction>(
  '/api/core/orgrolefunction',
  'OrgRoleFunction',
);
